/* eslint-disable */
var templates = [
    {
        text: "Only numbers",
        value: "/^[0-9]*$/",
        example: "12345"
    },
    {
        text: "Only letters",
        value: "/^[a-zA-Z]+$/",
        example: "abcDEF"
    },
    {
        text: "Only lowercase letters",
        value: "/^[a-z]+$/",
        example: "abc"
    },
    {
        text: "Only uppercase letters",
        value: "/^[A-Z]+$/",
        example: "ABC"
    },
    {
        text: "Email address",
        value: "/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/",
        example: "test@example.com"
    },
    {
        text: "URL",
        value: "/^https?:\\/\\/.+$/",
        example: "https://example.com"
    },
    {
        text: "Date (YYYY-MM-DD)",
        value: "/^\\d{4}-\\d{2}-\\d{2}$/",
        example: "2026-06-11"
    },
    {
        text: "Boolean (true/false/1/0)",
        value: "/^(true|false|1|0)$/",
        example: "true"
    },
    {
        text: "Decimal number",
        value: "/^\\d+(\\.\\d+)?$/",
        example: "123.45"
    }
];

export default templates;